/**
 * Conversion OS — Scroll Progress Bar Web Component
 *
 * Thin progress bar at the top of the page indicating scroll depth.
 * Purely visual — helps users understand how much content remains.
 * Uses requestAnimationFrame for smooth performance.
 */

if (!customElements.get('scroll-progress-bar')) {
  customElements.define(
    'scroll-progress-bar',
    class ScrollProgressBar extends HTMLElement {
      connectedCallback() {
        this.innerHTML = '<div class="cos-scroll-progress__bar"></div>';
        this.bar = this.querySelector('.cos-scroll-progress__bar');
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateProgress();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.updateProgress();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }

      updateProgress() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        this.bar.style.width = Math.min(100, progress) + '%';
      }
    }
  );
}
